import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { isLocalMediaAttachment } from 'stream-chat-react';

import PdfIcon from '@ps-design-system/icons/PDF/Pdf24';
import VideoIcon from '@ps-design-system/icons/Video/Video24';

import { AttachmentPreview } from './attachment-preview';

export const FileAttachmentPreview = ({ attachment = {}, removeAttachments, handleRetry }) => {
  const { localMetadata } = attachment;
  const { uploadState, id, file } = localMetadata;
  const { name, size } = file;
  const Icon = useMemo(() => {
    return isLocalMediaAttachment(attachment) ? VideoIcon : PdfIcon;
  }, [attachment]);

  const remove = useCallback(() => {
    removeAttachments([id]);
  }, [id, removeAttachments]);

  const retry = useCallback(() => {
    handleRetry(attachment);
  }, [id, handleRetry]);

  return (
    <AttachmentPreview
      Icon={Icon}
      state={uploadState}
      remove={remove}
      retry={retry}
      name={name}
      size={size}
    />
  );
};

FileAttachmentPreview.propTypes = {
  attachment: PropTypes.object,
  removeAttachments: PropTypes.func,
  handleRetry: PropTypes.func
};
